module.exports = __webpack_public_path__ + "images/project-logo-83998f5411cd27524cded338e4e2e137.jpg";